/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScanToPayPaymentTokenQueryVariables = Types.Exact<{
  paymentMethodId: Types.Scalars['String']['input'];
  useCredit: Types.Scalars['Boolean']['input'];
}>;

export type ScanToPayPaymentTokenQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename: 'LoyaltyProfile';
    readonly customerId: string;
    readonly customerToken:
      | {
          readonly __typename: 'CustomerTokenError';
          readonly code: string;
          readonly errorMessage: string;
        }
      | {
          readonly __typename: 'LoyaltyAccessToken';
          readonly token: string;
          readonly expiresAt: string;
        }
      | null;
  } | null;
};

export const ScanToPayPaymentTokenDocument = gql`
  query ScanToPayPaymentToken($paymentMethodId: String!, $useCredit: Boolean!) {
    loyaltyProfile {
      customerId
      __typename
      customerToken(
        purpose: PAYMENT
        paymentMetadata: { paymentMethodId: $paymentMethodId, useCredit: $useCredit }
      ) {
        ... on LoyaltyAccessToken {
          token
          expiresAt
          __typename
        }
        ... on CustomerTokenError {
          code
          errorMessage
          __typename
        }
      }
    }
  }
`;

export function useScanToPayPaymentTokenQuery(
  options: Omit<Urql.UseQueryArgs<ScanToPayPaymentTokenQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ScanToPayPaymentTokenQuery, ScanToPayPaymentTokenQueryVariables>({
    query: ScanToPayPaymentTokenDocument,
    ...options,
  });
}
